import TextConverter from './textConverter';
import NumConverter from './numConverter';
import DateConverter from './dateConverter';
import { aggMap } from '@/constantEnum';

class Converter {
  constructor() {
    this.converterList = {
      text: new TextConverter(),
      num: new NumConverter(),
      date: new DateConverter()
    };
  }

  toQuery({ fieldDetail, isRow, isCol }) {
    const fieldItem = this.fetchDefaultInfo({ item: fieldDetail, isRow });
    const converterEl = this.converterList[fieldItem.field_type];
    return converterEl.toQuery(fieldItem, { fieldDetail, isRow, isCol });
  }

  toFrontEndVal({ fieldItem, isRow, isCol }) {
    const converterEl = this.converterList[fieldItem.field_type];
    return converterEl.toFrontEndVal({ fieldItem, isRow, isCol });
  }

  fetchDefaultInfo({ item, isRow }) {
    const defaultInfo = {
      field: item.columnKey,
      field_type: item.type,
      deputy_field_type: item.deputy_type,
      field_name: item.title,
      agg_type: aggMap[item.type],
      type: isRow ? '行' : '列'
    };
    return defaultInfo;
  }
}

export default new Converter();
